import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from './pagination-button.module.scss';

export type PaginationButtonProps = {
  current?: boolean;
  isArrow?: boolean;
  showText?: boolean;
  customActiveStyle?: boolean;
  currentPage?: number;
} & React.HTMLProps<HTMLButtonElement>;

const PaginationButton: React.FC<PaginationButtonProps> = (props) => {
  const {
    currentPage,
    current = false,
    isArrow = false,
    showText = false,
    children,
    customActiveStyle,
    ...buttonProps
  } = props;

  const { t: tA11y } = useTranslation('a11y');

  return (
    <button
      type="button"
      className={clsx(
        styles.paginationButton,
        { [styles['paginationButton--current']]: current },
        {
          [styles['paginationButton--current--customActive']]: current && customActiveStyle,
        },
        { [styles['paginationButton--arrow']]: isArrow },
        { [styles['paginationButton--showText']]: showText },
      )}
      data-cy={currentPage ? `pagination-button-${currentPage}` : 'pagination-button'}
      aria-current={current ? 'page' : undefined}
      aria-label={
        !buttonProps.disabled && currentPage != null
          ? tA11y('A11Y.PAGE_NUMBER', { pageNumber: currentPage })
          : undefined
      }
      {...(buttonProps as React.HTMLAttributes<HTMLButtonElement>)}
    >
      {children}
    </button>
  );
};

export default PaginationButton;
